import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomeComponent } from './pages/home/home.component';
import { Homepage1Component } from './pages/homepage1/homepage1.component';
import { Homepage2Component } from './pages/homepage2/homepage2.component';
import { Homepage3Component } from './pages/homepage3/homepage3.component';
import { Homepage4Component } from './pages/homepage4/homepage4.component';
import { BlogComponent } from './pages/blog/blog.component';
import { Blogstyle2Component } from './pages/blogstyle2/blogstyle2.component';
import { BlogdetailsComponent } from './pages/blogdetails/blogdetails.component';
import { ExdealsComponent } from './pages/exdeals/exdeals.component';
import { AboutComponent } from './pages/about/about.component';
import { Restaurantstyle1Component } from './pages/restaurantstyle1/restaurantstyle1.component';
import { Restaurantstyle2Component } from './pages/restaurantstyle2/restaurantstyle2.component';
import { AddrestaurantComponent } from './pages/addrestaurant/addrestaurant.component';
import { ListviewComponent } from './pages/listview/listview.component';
import { CheckoutComponent } from './pages/checkout/checkout.component';
import { OrderdetailsComponent } from './pages/orderdetails/orderdetails.component';
import { GeolocatorComponent } from './pages/geolocator/geolocator.component';
import { ContactComponent } from './pages/contact/contact.component';
import { ErrorPageComponent } from './pages/error-page/error-page.component';
import { CheckinComponent } from './pages/checkin/checkin.component';
import { QrRedirectComponent } from './pages/qr-redirect/qr-redirect.component';
import { MainLayoutComponent } from './layouts/main-layout/main-layout.component';
import { AuthGuard } from '@core/guards/auth.guard';
import { UnauthGuard } from '@core/guards/unauth.guard';
import { AppointmentsListComponent } from './pages/appointments/appointments-list/appointments-list.component';
import { NotificationsComponent } from './pages/notifications/notifications.component';
const routes: Routes = [
  {
    path: '',
    component: MainLayoutComponent,
    children: [
      { path: '', component: HomeComponent },
      { path: 'stores', component: QrRedirectComponent },
      { path: 'checkin', component: CheckinComponent },
      { path: 'blog', component: BlogComponent },
      { path: 'blog-details/:postId', component: BlogdetailsComponent },
      { path: 'blog-details', component: BlogdetailsComponent },
      {
        path: 'businesses',
        loadChildren: () =>
          import('./pages/stores/stores.module').then((m) => m.StoresModule),
      },
      { path: 'add-business', component: AddrestaurantComponent },
      {
        path: 'checkout',
        canActivate: [AuthGuard],
        component: CheckoutComponent,
      },
      {
        path: 'account',
        canActivate: [AuthGuard],
        loadChildren: () =>
          import('./pages/account/account.module').then((m) => m.AccountModule),
      },
      {
        path: 'appointments',
        canActivate: [AuthGuard],
        loadChildren: () =>
          import('./pages/appointments/appointments.module').then(
            (m) => m.AppointmentsModule
          ),
      },
      {
        path: 'notifications',
        canActivate: [AuthGuard],
        component: NotificationsComponent,
      },
      { path: 'error-page', component: ErrorPageComponent },
    ],
  },
  {
    path: 'auth',
    canActivate: [UnauthGuard],
    loadChildren: () =>
      import('./pages/auth/auth.module').then((m) => m.AuthModule),
  },
  { path: '**', component: ErrorPageComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { relativeLinkResolution: 'legacy' })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
